import { inject, Injectable, signal } from '@angular/core';
import * as config from '../config/app.config';
import { BaseService } from './base.service';
import { first, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { B2BUnitModel, DefaultB2BUnit } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class B2bUserService {
  private readonly baseService = inject(BaseService);
  b2bUser = signal<DefaultB2BUnit | null>(null);

  constructor() {
  }

  getCurrentB2BUser(): Observable<DefaultB2BUnit> {
    return this.baseService.get(config.GET_ACCOUNT_ID)
      .pipe(
        first(Boolean),
        map((b2bResponse: B2BUnitModel) => b2bResponse.defaultB2BUnit),
        tap(b2User => this.b2bUser.set(b2User))
      );
  }

  getB2BUserById(userId: string): Observable<DefaultB2BUnit> {
    return this.baseService.get('users/' + userId + '/b2bUnits')
      .pipe(
        first(Boolean),
        map((b2bResponse: B2BUnitModel) => b2bResponse.defaultB2BUnit),
        tap(b2User => this.b2bUser.set(b2User))
      );
  }


  resetUser(): void {
    this.b2bUser.set(null);
  }
}
